import {isRejectedWithValue, Middleware} from '@reduxjs/toolkit';

import {isNotNil} from 'ramda';

import {recordAiAssistantError} from '@dms/ai-assistant';

import {getApiErrorInfo} from './getApiErrorInfo';
import {getApiErrorRoute} from './getApiErrorRoute';

/**
 * Records RTK Query failures (rejected-with-value) into the store's `recentErrors`, including the
 * failed route. One global middleware covers every API slice without touching the shared base query.
 */
export const recordApiErrorMiddleware: Middleware = () => (next) => (action) => {
  if (isRejectedWithValue(action)) {
    const route = getApiErrorRoute(action.meta);
    recordAiAssistantError({
      source: 'api',
      ...getApiErrorInfo(action.payload),
      ...(isNotNil(route) ? {route} : {}),
    });
  }

  return next(action);
};
